import * as React from 'react';
import { makeStyles, tokens, Text, Button } from '@fluentui/react-components';
import { useIntl } from 'react-intl';
import type { WorkspaceInfo } from '../auth/types';
import { Header } from '../components/Header';
import { workspaceResolverMessages } from '../intl/messages';
import { useWorkspaceResolver } from '../sync/WorkspaceResolverContext';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    padding: tokens.spacingHorizontalXXL,
    gap: tokens.spacingVerticalM,
    textAlign: 'center',
  },
  title: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase500,
  },
  description: {
    color: tokens.colorNeutralForeground2,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    marginTop: tokens.spacingVerticalM,
  },
});

type Props = {
  matchingWorkspaces: WorkspaceInfo[];
};

export function AmbiguousWorkspaceView({ matchingWorkspaces }: Props) {
  const styles = useStyles();
  const intl = useIntl();
  const { pickWorkspace } = useWorkspaceResolver();

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <Text className={styles.title}>
          {intl.formatMessage(workspaceResolverMessages.ambiguousTitle)}
        </Text>
        <Text className={styles.description}>
          {intl.formatMessage(workspaceResolverMessages.ambiguousDescription)}
        </Text>
        <div className={styles.list}>
          {matchingWorkspaces.map(app => (
            <Button
              key={app.accountId}
              appearance="primary"
              onClick={() => pickWorkspace(app)}
            >
              {app.displayName}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
